export function matchingFeedShapes(shapes: any[], info: any, includeAll: boolean): any[] {
  const matches = (shapes ?? []).filter((shape) =>
    shape.sceneId ? shape.sceneId === info?.sceneId : shape.id === info?._id
  );
  return includeAll ? matches : matches.slice(0, 1);
}

export function shapeLayerName(shape: any): string {
  return String(shape?.layerName ?? shape?.layername ?? '').trim();
}

export function combineWfsCollections(collections: any[]): any {
  const first = collections[0] ?? {};
  const forecastDetails = collections.reduce(
    (details, collection) => details.concat(
      Array.isArray(collection?.forecast_details) ? collection.forecast_details : []
    ),
    [] as any[]
  );
  return {
    ...first,
    type: 'FeatureCollection',
    features: collections.reduce(
      (features, collection) => features.concat(
        Array.isArray(collection?.features) ? collection.features : []
      ),
      [] as any[]
    ),
    forecast_details: forecastDetails.length ? forecastDetails : first.forecast_details,
  };
}

// Oil spill detection polygons (hour 0 or none) always show; flood forecast polygons
// (hour > 0) step through the time series like oil spill forecast points.
export function predictionFeaturesAtHours(features: any[], visibleHours: Set<string>): any[] {
  return (features ?? []).filter((feature) => {
    const geometryType = feature?.geometry?.type;
    const hour = feature?.properties?.forecast_h ?? feature?.properties?.forecast_hour;
    const isPolygon = geometryType === 'Polygon' || geometryType === 'MultiPolygon';
    if (isPolygon && !(Number(hour) > 0)) return true;
    return hour != null && visibleHours.has(String(hour).trim());
  });
}
